/**
 * @file paddlex 历史版本
 * @author FengGuang(fengguang01@baidu.com)
 */
import React, {useEffect} from 'react';

import Header from '../../../../components/header/HeaderWithStore';
import Banner from '../../../../components/banner/Banner';
import Footer from '../../../../components/footer/footer';
import MarkdownContainer from '../../../../components/markdown-container/MarkdownContainer';
import useReleaseNoteHooks from './paddlexReleaseNoteHooks';
import {Button} from 'antd';

const PaddlexReleaseNote: React.FC = props => {
    const {
        banner,
        releaseNote
    } = useReleaseNoteHooks();

    useEffect(() => {
        const scrollToAnchor = () => {
            const anchorName = window.location.hash.slice(1);
            if (!anchorName) {
                return;
            }
            const anchorDom = document.getElementById(anchorName)
                || document.querySelector(`a[name="${anchorName}"]`);
            if (anchorDom) {
                anchorDom.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        };

        scrollToAnchor();
        setTimeout(scrollToAnchor, 500);
    }, [releaseNote]);

    return (
        <div className="page paddle-lab-release-note-page">
            <Header />
            <Banner
                title={banner.title}
                className="paddle-lab-release-note-banner"
                subtitle={banner.subtitle}
            >
                {banner.btns.length > 0
                && (
                    <div className="paddle-lab-release-note-banner-btn-group">
                        {banner.btns?.map((btn: any) => (
                            <a
                                key={`${btn.label}${btn.href}`}
                                href={btn.href}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <Button
                                    type="primary"
                                    size="large"
                                    className="paddle-lab-release-note-banner-btn"
                                >
                                    {btn.label}
                                </Button>
                            </a>
                        ))}
                    </div>
                )}
            </Banner>
            <div className="paddle-lab-release-note-container">
                <MarkdownContainer source={releaseNote} />
            </div>
            <Footer />
        </div>
    );
};

export default PaddlexReleaseNote;
